import Admin from "../Admin";
import React from "react";
import CardAdminHcpcsCodeList from "../../../Component/Card/Admin/HcpcsCode/CardAdminHcpcsCodeList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class HcpcsCodeList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminHcpcsCodeList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/hcpcsCode",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Hcpcs Codes" buttons={buttons} />;
  }
}
